const checkOutDiv = document.querySelector('#rk_checkout_div');
const rkFtc = document.querySelectorAll('.rk_rfc_btn')

if(rkFtc.length > 0) {
    checkOutDiv.style.display = 'block';
}

document.addEventListener('rk_cart_event', function (e) {
    checkOutDiv.style.display = 'none';
    location.reload();
}, false);

window.onload = function() {
    const element = document.querySelector('[data-recipient-checkbox]');
    if (element) {
        element.click();
    }
};

/* ============================================================
   Oaktown custom — Search results: show products + ALL recipes
   ------------------------------------------------------------
   Shopify's combined "all results" search view is relevance-ranked
   and only surfaces a couple of recipes (articles), hiding the rest
   behind the "Blogs" tab. Most visitors never notice that tab, or
   don't realise "Blogs" means "Recipes".

   This removes the products/blogs tab toggle on the search results
   page and merges EVERY matching recipe into the same results grid as
   the products, so it all shows as one continuous grid on first view.

   - Products are kept exactly as the native (relevance-ranked) view
     shows them, so we don't dump the full fuzzy product match list.
   - Recipes are pulled from a dedicated article search and paged
     through to the end, so all matches are shown, not just a subset.
   - Fails safe: if anything goes wrong the native tabbed view is
     left untouched.
   ============================================================ */
(function () {
  function enhanceSearchResults() {
    var section = document.querySelector(
      '[data-section-type="search-template"][data-search-performed="true"]'
    );
    if (!section || section.hasAttribute('data-full-results-init')) return;
    // Only the combined, multi-type search view needs fixing.
    if (section.getAttribute('data-all-types') !== 'true') return;

    var allTypes = section.querySelector('[data-all-types-container]');
    var form = section.querySelector('[data-search-form]');
    var sectionId = section.getAttribute('data-section-id');
    var nav = section.querySelector('.search-page__nav');
    if (!allTypes || !form || !sectionId) return;

    var term = ((new FormData(form).get('q')) || '').trim();
    if (!term) return;

    section.setAttribute('data-full-results-init', '');

    var searchUrl =
      (window.theme && theme.routes && theme.routes.searchUrl) || '/search';

    function typeUrl(type) {
      return (
        searchUrl +
        '?q=' + encodeURIComponent(term) +
        '&type=' + type +
        '&section_id=' + encodeURIComponent(sectionId)
      );
    }

    function withSection(href) {
      var u = new URL(href, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      return u.toString();
    }

    // Walk every paginated page of `type` and return the first page's
    // results-tab element with all items merged into its grid.
    function loadAllOfType(type, tabSelector, itemSelector) {
      var firstTab = null;
      var grid = null;
      var seen = {}; // guard against ever re-fetching the same page

      function fetchPage(url, isFirst) {
        seen[url] = true;
        return fetch(url)
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var tab = doc.querySelector(tabSelector);
            if (!tab) return firstTab;

            var items = tab.querySelectorAll(itemSelector);
            if (isFirst) {
              firstTab = tab;
              if (items.length) grid = items[0].parentElement;
            } else if (grid) {
              items.forEach(function (it) {
                grid.appendChild(it);
              });
            }

            // Follow ONLY the genuine "next page" link, so we chain
            // forward to the last page and stop. We must not match the
            // numbered/"previous" links in the <noscript> fallback
            // pagination (DOMParser parses <noscript> as real DOM),
            // otherwise we'd bounce between pages and duplicate results.
            // - infinite-scroll mode: the loader holds the next link
            // - standard mode: Shopify marks it rel="next" (absent on
            //   the last page)
            var next = tab.querySelector(
              '.pagination__loading a[href], a[rel="next"]'
            );
            var nextHref = next && next.getAttribute('href');
            var nextUrl = nextHref ? withSection(nextHref) : null;
            if (
              nextUrl &&
              !seen[nextUrl] &&
              grid &&
              grid.querySelectorAll(itemSelector).length < 250
            ) {
              return fetchPage(nextUrl, false);
            }
            return firstTab;
          });
      }

      return fetchPage(typeUrl(type), true);
    }

    loadAllOfType('article', '[data-tab="resultsArticles"]', '.blog__post-item')
      .then(function (recipesTab) {
        var recipeItems = recipesTab
          ? recipesTab.querySelectorAll('.blog__post-item')
          : [];
        if (!recipeItems.length) return; // No recipes — leave page as-is.

        // Target the combined results grid (products + the few
        // relevance-ranked recipes) — everything goes in here so it
        // stays a single grid.
        var grid =
          allTypes.querySelector('[data-collection-products] .grid') ||
          allTypes.querySelector('.grid');
        if (!grid) return; // No grid to merge into — leave page as-is.

        // 1) Hide the products / blogs toggle.
        if (nav) {
          nav.classList.add('hidden');
          nav.style.display = 'none';
        }

        // 2) Remove the few buried recipes already in the grid so the
        //    full recipe list below doesn't duplicate them.
        grid.querySelectorAll('.blog__post-item').forEach(function (el) {
          el.remove();
        });

        // 3) Append every matching recipe into the same grid. The items
        //    already carry the grid sizing classes, so they tile in with
        //    the products as one continuous grid. Strip ids (avoid
        //    duplicate-id clashes across paginated batches) and force
        //    AOS-animated items visible, since AOS won't observe nodes
        //    added after page load.
        recipeItems.forEach(function (item) {
          item.removeAttribute('id');
          if (item.hasAttribute('data-aos')) item.classList.add('aos-animate');
          item.querySelectorAll('[data-aos]').forEach(function (el) {
            el.classList.add('aos-animate');
          });
          grid.appendChild(item);
        });
      })
      .catch(function (err) {
        // Fail safe: native tabbed view stays in place.
        if (window.console && console.warn) {
          console.warn('[search] full results enhancement skipped:', err);
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceSearchResults);
  } else {
    enhanceSearchResults();
  }
})();


// PDP featured blog fix
const fetchBlogPostsBeyondPage1 = () => {
  const featuredBlogSection = document.querySelector('.custom__featured-blog');
  if (!featuredBlogSection) return;

  document.querySelectorAll('[data-section-type="blog-posts"]').forEach(function (section) {
    const grid = section.querySelector('[id^="BlogPostGrid--"]');
    if (!grid) return;

    const totalPages = parseInt(grid.dataset.totalPages, 10);
    if (totalPages <= 1) return;

    const sectionId = section.dataset.sectionId;
    const currentUrl = new URL(window.location.href);

    for (let page = 2; page <= totalPages; page++) {
      currentUrl.searchParams.set('page', page);
      currentUrl.searchParams.set('section_id', sectionId);

      fetch(currentUrl.toString())
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newItems = doc.querySelectorAll('[id^="BlogPostGrid--"] > *');
          newItems.forEach(item => grid.appendChild(item));
        })
        .catch(err => console.error('Blog page fetch error:', err));
    }
  });
};
document.addEventListener("DOMContentLoaded", fetchBlogPostsBeyondPage1);
document.addEventListener('shopify:section:load', fetchBlogPostsBeyondPage1);